__turbopack_context__.v({
  "footer": "LoginForm-module__2gJdEG__footer",
  "form": "LoginForm-module__2gJdEG__form",
});
